import { render, staticRenderFns } from "./DialogCreateDepartmentFromCompany.vue?vue&type=template&id=d1d8cfdc&scoped=true&"
import script from "./DialogCreateDepartmentFromCompany.vue?vue&type=script&lang=js&"
export * from "./DialogCreateDepartmentFromCompany.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateDepartmentFromCompany.vue?vue&type=style&index=0&id=d1d8cfdc&lang=scss&scoped=true&"
import style1 from "./DialogCreateDepartmentFromCompany.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d8cfdc",
  null
  
)

export default component.exports